export default "__VITE_ASSET__5ac2c81c__"